var render, staticRenderFns
import script from "./ModelList.vue?vue&type=script&lang=js&"
export * from "./ModelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('116655d2')) {
      api.createRecord('116655d2', component.options)
    } else {
      api.reload('116655d2', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Model/resources/vue/ModelList.vue"
export default component.exports